import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import Login from './pages/Login';
import Register from './pages/Register';
import MainTabNavigator from './pages/MainTabNavigator';
import Dashboard from './pages/Dashboard';
import CampaignDashboard from './pages/CampaignDashboard';
import UserManagement from './pages/UserManagement';
import MatrixDashboard from './pages/MatrixDashboard';
import CohortRetention from './pages/CohortRetention';
import RepeatAnalysis from './pages/RepeatAnalysis';
import SpendAnalysis from './pages/SpendAnalysis';
import MarketingSpendAnalysis from './pages/MarketingSpendAnalysis';
import LtvAnalysis from './pages/LtvAnalysis';
import MonthAnalytics from './pages/MonthAnalytics';
import OrderTimePreference from './pages/OrderTimePreference';

function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <Routes>
        {/* Public routes */}
        <Route 
          path="/login" 
          element={user ? <Navigate to="/menu" replace /> : <Login />} 
        />
        <Route 
          path="/register" 
          element={user ? <Navigate to="/menu" replace /> : <Register />} 
        />
        
        {/* Protected routes */}
        <Route 
          path="/" 
          element={user ? <Navigate to="/menu" replace /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/dashboard" 
          element={user ? <Dashboard /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/campaign-dashboard" 
          element={user ? <CampaignDashboard /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/user-management" 
          element={user ? <UserManagement /> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/menu" 
          element={user ? <MainTabNavigator /> : <Navigate to="/login" replace />} 
        />
        <Route
          path="/matrix"
          element={user ? <MatrixDashboard /> : <Navigate to="/login" replace />}
        />
        <Route
          path="/cohort-retention"
          element={user ? <CohortRetention /> : <Navigate to="/login" replace />}
        />
        <Route
          path="/repeat-analysis"
          element={user ? <RepeatAnalysis /> : <Navigate to="/login" replace />}
        />
        <Route
          path="/spend-analysis"
          element={user ? <SpendAnalysis /> : <Navigate to="/login" replace />}
        />
        <Route
          path="/marketing-spend"
          element={user ? <MarketingSpendAnalysis /> : <Navigate to="/login" replace />}
        />
        <Route
          path="/ltv-analysis"
          element={user ? <LtvAnalysis /> : <Navigate to="/login" replace />}
        />
        <Route
          path="/month-analytics"
          element={user ? <MonthAnalytics /> : <Navigate to="/login" replace />}
        />
        <Route
          path="/order-time-preference"
          element={user ? <OrderTimePreference /> : <Navigate to="/login" replace />}
        />
        
        {/* Catch all route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App; 